<template>
  <div>
    <!--S 右侧区域-->
    <!-- <transition name="slide-right"> -->
    <keep-alive :max="2">
      <router-view v-if="$route.meta.keepAliv"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAliv"></router-view>
    <!-- </transition> -->
    <!--E 右侧区域-->
  </div>
</template>
<script>
export default {
  name: "Templent_Order",
  data() {
    return {
    };
  },
  filters: {},
  components: {},
  methods: {
  },
  created() {},
  watch: {},
  mounted() {},
  computed: {}
};
</script>

<style>
.simpleSearch{display: inline-block;line-height: 40px;color: var(--main-color);cursor: pointer;white-space: nowrap;margin-left: 10px;}
</style>



// WEBPACK FOOTER //
// src/views/StatisticsFolder/Templent_Statistics.vue